import {
  SYSTEM_USERTAG_MODAL_CHANGE,
} from './constants';

export function userTagModalChange(visible,type) {
  return {
    type: SYSTEM_USERTAG_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_USERTAG_MODAL_CHANGE:
      return {
        ...state,
        userTagModalType:action.data.type,
        userTagModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/userTagModalChange.js